const METRICS = {
  PREANON: "preanon_tracking",
  FACESWAP: "faceswap_metric",
};

Object.freeze(METRICS);

export { METRICS };
